import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=5ce5f3dc&scoped=true"
import script from "./receipt-detail.vue?vue&type=script&lang=js"
export * from "./receipt-detail.vue?vue&type=script&lang=js"
import style0 from "./receipt-detail.vue?vue&type=style&index=0&id=5ce5f3dc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5f3dc",
  null
  
)

export default component.exports